// extracted by mini-css-extract-plugin
export default {"button":"lyj8uJZNfrh6h7sMbMNA","buttonContent":"Fo3F7YwyO8869LBMNdEy","buttonSmall":"x7vmXfQWYLeRHCTB0asB","buttonIcon":"mt1bFXvPLDq2I6rANqNb","buttonText":"QZg4IgAyu1iJiu5TSkiQ"};